<template>
  <div class="position-relative">
    <div
      ref="actions-button"
      class="table__select-options"
      @click="toggleActions"
    >
      <i class="material-icons md-dark-blue">more_horiz</i>
    </div>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-show="isShown"
        ref="actions-modal"
        class="table__select-options__modal active"
        :class="{'top': isTop}"
      >
        <div
          v-if="userCanBeEdited"
          class="table__select-options__wrapper"
          @click="editUser"
        >
          <i class="material-icons">create</i>
          <span class="table__select-options__wrapper__text" v-text="userReadOnly ? 'Просмотр ' : 'Редактировать'"></span>
        </div>
        <div
          v-if="userCanBeBlocked && !userReadOnly"
          class="table__select-options__wrapper"
          @click="blockUser"
        >
          <i class="material-icons">lock</i>
          <span class="text-danger">
            Заблокировать
          </span>
        </div>
        <div
          v-if="userCanChangePassword && !userReadOnly"
          class="table__select-options__wrapper"
          @click="resetPassword"
        >
          <i class="material-icons">cached</i>
          <span class="table__select-options__wrapper__text text-danger">
            Сбросить пароль
          </span>
        </div>
        <!-- <div
          class="table__select-options__wrapper"
          @click="deleteUser"
        >
          <i class="material-icons">delete_outline</i>
          <span class="table__select-options__wrapper__text">
            <span class="text-danger">Удалить</span>
          </span>
        </div> -->
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'UserActions',
  props: {
    user: {
      type: Object,
      required: true,
    },
    roleList: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isShown: false,
    isTop: false,
  }),
  computed: {
    userCanChangePassword() {
      return this.$store.state.user.canChangePassword && this.canBeModifiedByBusinessSVO;
    },
    userCanBeBlocked() {
      return this.roleList.filter(it => this.user.role.includes(it.name) && it.isSelect).length && this.user.role.length && this.canBeModifiedByBusinessSVO;
    },
    userReadOnly() {
      return this.$store.state.user.interfaces.includes('UM-SVO-readonly');
    },
    userCanBeEdited() {
      return this.canBeModifiedByBusinessSVO;
    },
    canBeModifiedByBusinessSVO() {
      const currentUserRoles = this.$store.state.user.role || [];
      const selectedUserRoles = this.user.role || [];

      const isBusinessSVO = currentUserRoles.includes('businessSVO');
      const canBeEditedByBusinessSVO = ["dealerAdministratorSVO", "dealerSVO", "readOnlySVO", "businessSVO"];
      const isCanBeEditedByBusinessSVO = selectedUserRoles.some((role) => canBeEditedByBusinessSVO.includes(role));

      return !(isBusinessSVO && !isCanBeEditedByBusinessSVO);
    }
  },
  created() {
    document.addEventListener('click', this.onOutsideClickHandler);
  },
  destroyed() {
    document.removeEventListener('click', this.onOutsideClickHandler);
  },
  methods: {
    toggleActions() {
      this.isShown = !this.isShown;

      // Add class 'top' if the modal is outside of the table
      this.isTop = false;

      this.$nextTick(() => {
        const modalBottom = this.$refs['actions-modal'].getBoundingClientRect().bottom;
        const tableBottom = document.querySelector('.table-wrapper').getBoundingClientRect().bottom;

        if (modalBottom > tableBottom) {
          this.isTop = true;
        }
      });
    },
    onOutsideClickHandler(evt) {
      if (!this.$refs['actions-button'].contains(evt.target) && !this.$refs['actions-modal'].contains(evt.target)) {
        this.isShown = false;
      }
    },
    blockUser() {
      this.isShown = false;
      this.$emit('blockUser', this.user);
    },
    editUser() {
      this.isShown = false;
      this.$emit('editUser', this.user);
    },
    // async deleteUser() {
    //   this.$emit('deleteUser', this.user.id);
    // },
    async resetPassword() {
      this.$emit('resetPassword', this.user.id);
      this.toggleActions();
    },
  },
};
</script>

<style lang="scss" scoped>
.table__select-options__modal.disabled .table__select-options__wrapper {
  opacity: 0.65;
}

.interactive.table .table__select-options__modal.top {
  bottom: 35px;
}
</style>
